/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { logoStyle } from "assets/jss/material-kit-pro-react/components/headerStyle";

const styles = (theme) => {
  const titleBar = {
    color: "white",
    padding: "0.25rem 1rem",
  };

  return {
    titleBarPDF: {
      ...titleBar,
      backgroundColor: theme.palette.info.main,
    },

    titleText: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },

    pdfBody: {
      width: "100%",
      height: "100%",
    },

    ibxDial: {
      position: "absolute",
      bottom: "1rem",
      right: "1rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
    },

    dialGreen: {
      color: "white",
      background: theme.palette.secondary.main + "E0",
      "&:hover": { background: theme.palette.secondary.dark },
      pointerEvents: "auto",
    },

    dialOrange: {
      color: "white",
      background: theme.palette.primary.main + "E0",
      "&:hover": { background: theme.palette.primary.dark },
      pointerEvents: "auto",
    },

    playButton: {
      // style the playpause.svg
      width: "18px",
      height: "18px",
      filter: "invert(1.0)",
    },

    hoPageNum: {
      fontFamily: "Open Sans",
      fontWeight: 600,
      color: "white",
      padding: "0.25rem 0.75rem",
      borderRadius: "3px",
      backgroundColor: theme.palette.info.light,
      margin: "0.75rem 0 0.5rem 0",
    },

    logo: {
      ...logoStyle,
    },
  };
};

export default styles;
